import toast from 'react-hot-toast';
export default function HandleApprovalRequest(payload, targetUrl) {
  const feedbackUrl = `${window.location.origin}${targetUrl}`;
  toast(
    (t) => (
      <span>
        <span>New Approval request for {payload.poLine.documentNo}</span>
        <br />
        <a href={feedbackUrl} target="_blank" rel="noreferrer">
          View Now
        </a>
      </span>
    ),
    {
      icon: '🚨',
      style: {
        padding: '16px',
        color: '#713200'
      },
      id: payload.poLine.documentNo
    }
  );
}
